module.exports = __webpack_public_path__ + "img/template_placeholder_yellow@2x.57fc1e8.png";